module.exports = __webpack_public_path__ + "static/img/small_thumb_no_image.6cce592.jpg";